<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    let self = this;
    window.errHandle = function(data, context) {
      if (
        context.status == 401 ||
        context.status == 402 ||
        context.status == 403
      ) {
         self.$router.push("/");
      }
    };
  }
};
</script>
<style>
  .content{
    margin: 30px;
    padding: 30px;
  }
  .fff{
    background-color: #ffffff;
  }
  .borderRadius-10{
    border-radius: 10px;
  }
  .pagination{
    display: flex;
    justify-content: end;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue